import { hasPermissions } from "helpers";

export const HasPermissions = ({ children, requiredPermissions }) => {
	return hasPermissions(requiredPermissions) && children;
};
